import { combineReducers } from 'redux';

import bankingRequestReducer from './bankingRequest';
import homeReducer from './home';
import pcpReducer from './pcp';
import serviceBookingReducer from './serviceBooking';
import accessoryPcpPaginationReducer from '../../slices/pages/accessoryPcp';
import c2cReducer from '../../slices/pages/c2c';
import checkoutConfirmationReducer from '../../slices/pages/checkout/confirmation';
import checkoutDeliveryReducer from '../../slices/pages/checkout/delivery';
import favoritesReducer from '../../slices/pages/favorites';
import loginReducer from '../../slices/pages/login';
import myGarageReducer from '../../slices/pages/myGarage';
import ordersReducer from '../../slices/pages/orders/ordersStageSlice';
import pdpReducer from '../../slices/pages/pdp';
import pressPaginationReducer from '../../slices/pages/press';
import tradeInReducer from '../../slices/pages/tradein';

const pagesReducer = combineReducers({
  home: homeReducer,
  pcp: pcpReducer,
  pdp: pdpReducer,
  checkoutDelivery: checkoutDeliveryReducer,
  myGarage: myGarageReducer,
  serviceBooking: serviceBookingReducer,
  tradeIn: tradeInReducer,
  c2c: c2cReducer,
  bankingRequest: bankingRequestReducer,
  orders: combineReducers({
    stage: ordersReducer,
  }),
  checkoutConfirmation: checkoutConfirmationReducer,
  login: loginReducer,
  pressPagination: pressPaginationReducer,
  accessoryPcpPagination: accessoryPcpPaginationReducer,
  favorites: favoritesReducer,
});

export default pagesReducer;
